import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gcd5wc4rkp: FaireBrandEntity = {
  token: "b_gcd5wc4rkp",
  type: "brand",
  name: "Treat Yourself Boutiques",
  avatarUrl:
    "https://cdn.faire.com/fastly/5363aa5c7b4df99e502606fa82edcd9bd33a9430bf63ecef049e766d27b27c5b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1e5c33e053ec0364018cfb805bcbb881e693d3ca832dabf979dd6a618ee7c1ad.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5363aa5c7b4df99e502606fa82edcd9bd33a9430bf63ecef049e766d27b27c5b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1e5c33e053ec0364018cfb805bcbb881e693d3ca832dabf979dd6a618ee7c1ad.png",
  location: "LAVEEN, AZ, USA",
  minimumOrderDollars: 100,
  rating: 2.8,
  reviewCount: 8,
  isInsider: true,
  description:
    "Treat Yourself Boutiques is where joy meets variety.\nBorn from a love of playful indulgence and boutique charm, our brand brings together the best of snacks, accessories, and apparel — all curated to spark delight. Whether you're craving a chocolate fix, hunting for a bold new tee, or picking up a gift that pops, we’ve got something that says “you deserve this.”\nWe believe in the power of impulse joy — that moment when something catches your eye and makes you smile. That’s why every product we offer is designed to stand out: colorful, fun, and full of personality. From our signature treats to our boutique finds, everything is handpicked to feel special, without the fuss.\nOur vibe?\nThink candy shop meets curated closet. Think bold flavors, bright colors, and boutique energy that turns everyday moments into mini celebrations.\nOur promise?\nNo matter what you grab, it’ll feel like a treat — because you deserve it.\n**NOTE WE DO NOT CANCEL ORDERS ONCE PLACED UNLESS THERE IS A DELAY ON OUR END AND WE CAN NOT HOLD OUR SHIP DATE PLEASE BE SURE WHEN PLACING ORDERS AS CANCELED ORDERS AFFECTS OUR PLATFORM ANALYTICS**",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:34.791Z",
    importedBy: "entity-db-cli",
  },
};
